import { Alert, Button } from '@relay-towing/ui';

/**
 * Shown where a screen would say what the caller's role does not allow, when
 * the permissions could not be loaded. Saying "you need the permission" then
 * would be a guess, and usually a wrong one.
 */
const PermissionsErrorAlert = ({ onRetry }: { onRetry: () => void }) => (
  <Alert
    tone="destructive"
    title="Could not load your permissions"
    actions={
      <Button variant="outline" size="sm" onClick={onRetry}>
        Try again
      </Button>
    }
  >
    Check your signal and try again.
  </Alert>
);

export default PermissionsErrorAlert;
